export const formatPermitTrackingId = (permit) => {
  if (!permit) return "";

  const formatSegment = (value) => {
    if (value === null || value === undefined) return "na";

    const normalized = String(value).trim();
    if (!normalized) return "na";

    return normalized.replace(/\//g, "-");
  };

  const scheduleDate = permit.scheduleStart
    ? new Date(permit.scheduleStart)
    : null;
  const formattedDate =
    scheduleDate && !Number.isNaN(scheduleDate.getTime())
      ? `${scheduleDate.getFullYear()}${String(
          scheduleDate.getMonth() + 1,
        ).padStart(2, "0")}${String(scheduleDate.getDate()).padStart(2, "0")}`
      : "nodate";

  return [
    formatSegment(permit.siteName),
    formatSegment(permit.receiverDepartmentName),
    formatSegment(permit.id),
    formattedDate,
  ].join("/");
};
